(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/page-header/assets/javascripts/page-header.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/page-header/assets/javascripts/page-header.js');
"use strict";

var _svs$core;

const _React = React,
  useMemo = _React.useMemo;
const _ref = ((_svs$core = svs.core) === null || _svs$core === void 0 || (_svs$core = _svs$core.session) === null || _svs$core === void 0 || (_svs$core = _svs$core.data) === null || _svs$core === void 0 ? void 0 : _svs$core.userSession) || undefined,
  firstName = _ref.firstName;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const injectName = str => str.replace(/{{firstName}}/g, firstName);
const PageHeader = _ref2 => {
  let _ref2$fallbackConfig = _ref2.fallbackConfig,
    fallbackConfig = _ref2$fallbackConfig === void 0 ? {} : _ref2$fallbackConfig,
    _ref2$headerConfig = _ref2.headerConfig,
    _ref2$headerConfig2 = _ref2$headerConfig === void 0 ? {} : _ref2$headerConfig,
    header = _ref2$headerConfig2.header,
    body = _ref2$headerConfig2.body,
    hideSection = _ref2$headerConfig2.hideSection,
    headerLoggedIn = _ref2$headerConfig2.headerLoggedIn,
    bodyLoggedIn = _ref2$headerConfig2.bodyLoggedIn;
  const finalConfig = useMemo(() => {
    if (header) {
      return {
        header: isLoggedIn && headerLoggedIn ? headerLoggedIn : header,
        body: isLoggedIn && bodyLoggedIn ? bodyLoggedIn : body,
        hideSection
      };
    }
    return fallbackConfig;
  }, [header, body, hideSection, headerLoggedIn, bodyLoggedIn, fallbackConfig]);
  if (finalConfig !== null && finalConfig !== void 0 && finalConfig.hideSection) {
    return null;
  }
  return React.createElement("section", {
    className: "bingo-page-header-section f-content"
  }, React.createElement("div", {
    className: "bingo-page-description"
  }, finalConfig.header && React.createElement("h2", {
    className: "bingo-page-description__header"
  }, injectName(finalConfig.header)), finalConfig.body && React.createElement("p", null, injectName(finalConfig.body))));
};
setGlobal('svs.bingo_react.components.page_header.PageHeader', PageHeader);

 })(window);